import type { AdminStepScorm, ScormProcessingStatus } from '@/entities/Courses';

/** Пакет обрабатывается на сервере: заменить или удалить его нельзя, пока обработка не закончится */
export const isScormProcessing = (status?: ScormProcessingStatus | null) =>
  status === 'queued' || status === 'processing';

/**
 * Незавершённую загрузку можно продолжить тем же файлом: бэкенд помнит выбранный файл, и срок
 * приёма частей не вышел (scorm.upload из деталей урока)
 */
export const isScormUploadResumable = (scorm: AdminStepScorm) =>
  scorm.processingStatus === 'uploading' &&
  !!scorm.upload &&
  (!scorm.upload.uploadExpiresAt || Date.parse(scorm.upload.uploadExpiresAt) > Date.now());

/**
 * Тот же файл (имя, размер, дата изменения), что выбран для незавершённой загрузки шага:
 * загрузка продолжается с принятых частей. Другой файл — новая загрузка
 */
export const isSameScormUploadFile = (scorm: AdminStepScorm | null | undefined, file: File) => {
  const upload = scorm?.upload;
  if (!scorm || !upload || !isScormUploadResumable(scorm)) return false;
  return (
    file.name === upload.fileName &&
    file.size === upload.fileSize &&
    file.lastModified === upload.fileLastModified
  );
};
